import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const createSalesforceChatMap = (userId, agentType) =>
  call(websocketFetch, 'create_salesforce_chat_map', {
    user_id: userId,
    agent_type: agentType,
    version: 1,
  });
